import { render, staticRenderFns } from "./ModalAditivoContrato.vue?vue&type=template&id=01820cd2&"
import script from "./ModalAditivoContrato.vue?vue&type=script&lang=js&"
export * from "./ModalAditivoContrato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports